import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { toggleVideo, sendTutorialEventData, markTutorialPlayed } from 'store/actions/activity';
import VideoPlayer from './VideoPlayer';
import closeButton from 'assets/svg/modal-close.svg';
import style from './VideoModal.module.scss';
import { captionFormat } from 'utils/caption-util';
import { withLwtStore } from '@lwtears/lwt-common-frontend/lib/LwtApp';
import { t } from '../../translations';

export class VideoModal extends React.Component {
  constructor(props) {
    super(props);
    this.autoplay = false;
    this.closeButton = React.createRef();
  }

  componentDidMount() {
    this.closeButton.current?.focus();
  }

  sendEvent = (autoplay, src, didComplete) => {
    this.props.sendTutorialEventData(autoplay, src, didComplete);
  };

  markTutorialPlayed = () => {
    this.props.markTutorialPlayed();
    // eslint-disable-next-line
  };

  getCaption = src => ({
    kind: 'captions',
    label: 'Default subtitle',
    src,
    default: true
  });

  render() {
    const { isVideoModalOpen, currentRoundIndex, activities, isLoading, toggleVideo } = this.props;

    const {
      closedCaptionsSettings,
      audioSettings,
      videoNarrationSettings: { showSettings }
    } = this.props.lwtStoreState.settings.accessibility;
    //eslint-disable-next-line

    if (!isVideoModalOpen) return null;
    if (currentRoundIndex < 0 || !activities || !activities.length) return null;
    if (isLoading && currentRoundIndex >= 0) return null;

    const currentRound = activities[currentRoundIndex];
    const activityName = activities[currentRoundIndex].type.split(/(?=[A-Z])/).join(' ');
    if (!currentRound || !currentRound.data.tutorial) return null;

    const { tutorial } = currentRound.data;

    let { autoplay } = tutorial;
    if (this.autoplay) {
      autoplay = false;
    } else {
      this.autoplay = tutorial.autoplay;
    }

    return (
      <div
        id="tutorial-modal"
        className={style.modalContainer}
        role="dialog"
        aria-modal={true}
        aria-label={`${t('TutorialOpened')}` + activityName + `${t('Activity')}`}
      >
        <div className={style.modal}>
          <button
            ref={this.closeButton}
            id="tutorial-modal-close-button"
            className={`gss-button ${style.closeButton}`}
            onClick={() => toggleVideo(false)}
            aria-label={t('btnClose')}
          >
            <img src={closeButton} alt={t('CloseBtn')} />
          </button>
          <VideoPlayer
            src={tutorial.src}
            caption={captionFormat(tutorial.vtt)}
            autoplay={autoplay}
            markTutorialPlayed={this.markTutorialPlayed}
            sendEvent={this.sendEvent}
            audioSettings={audioSettings}
            closedCaptionsSettings={closedCaptionsSettings}
            showSettings={showSettings}
            narrationVtt={tutorial.narrationVtt}
            narrationSrc={tutorial.narrationSrc}
          />
        </div>
      </div>
    );
  }
}

VideoModal.propTypes = {
  currentRoundIndex: PropTypes.number,
  activities: PropTypes.array,
  toggleVideo: PropTypes.func,
  isLoading: PropTypes.bool,
  isVideoModalOpen: PropTypes.bool,
  sendTutorialEventData: PropTypes.func,
  markTutorialPlayed: PropTypes.func,
  lwtStoreState: PropTypes.object
};

const mapStateToProps = state => ({
  isLoading: state.ui.loading,
  currentRoundIndex: state.activity.currentRoundIndex,
  activities: state.activity.activities,
  isVideoModalOpen: state.activity.isVideoModalOpen,
  lwtStoreState: PropTypes.object
});

export default connect(mapStateToProps, {
  toggleVideo,
  markTutorialPlayed,
  sendTutorialEventData
})(withLwtStore(VideoModal));
